import { render, staticRenderFns } from "./NewMessageButtonHeader.vue?vue&type=template&id=afdfba2c&scoped=true"
import script from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
export * from "./NewMessageButtonHeader.vue?vue&type=script&lang=js"
import style0 from "./NewMessageButtonHeader.vue?vue&type=style&index=0&id=afdfba2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdfba2c",
  null
  
)

export default component.exports